import { decodeHtml } from './decodeHtml.js';

export function mapOrderForClient(order, options = {}) {
  const { server = '' } = options;
  const items = Array.isArray(order.items) ? order.items : [];
  const shippingAddress =
    order.extension_attributes?.shipping_assignments?.[0]?.shipping?.address || null;
  const billingAddress = order.billing_address || null;

  const visibleItems = items.filter(
    item =>
      item.parent_item_id === null ||
      item.parent_item_id === undefined ||
      item.parent_item_id === 0
  );

  const lineItems = visibleItems.length ? visibleItems : items;

  return {
    server: order.server || server,
    entityId: order.entity_id,
    id: order.increment_id,
    status: order.status,
    createdAt: order.created_at,
    currency: order.order_currency_code,
    total: order.grand_total,
    totalItemCount: order.total_item_count,
    customerEmail: order.customer_email,
    customerName: `${order.customer_firstname || ''} ${order.customer_lastname || ''}`.trim(),
    shippingDescription: order.shipping_description || '',
    shippingAddress,
    billingAddress,
    items: lineItems.map(item => ({
      itemId: item.item_id,
      name: decodeHtml(item.name),
      sku: item.sku,
      qty: item.qty_ordered,
      qtyShipped: item.qty_shipped,
      price: item.price,
    })),
  };
}
